/**
 * StatExplainerSheet — Plain-language explainer for a tapped stat
 *
 * Small bottomsheet with title + explanation paragraphs.
 * Template-based (no AI call), instant render.
 */

import { T } from '@/styles/tokens';
import { BottomSheet } from '@/components/ui/BottomSheet';

interface StatExplainerSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  lines: string[];
}

export function StatExplainerSheet({ isOpen, onClose, title, lines }: StatExplainerSheetProps) {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <div style={{ padding: '8px 20px 32px' }}>
        <div style={{
          fontSize: 16,
          fontWeight: 700,
          color: T.text,
          fontFamily: T.fontFamily,
          marginBottom: 16,
        }}>
          {title}
        </div>
        {lines.map((line, i) => (
          <p
            key={i}
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: T.textSecondary,
              lineHeight: 1.6,
              fontFamily: T.fontFamily,
              margin: 0,
              marginBottom: i < lines.length - 1 ? 12 : 0,
            }}
          >
            {line}
          </p>
        ))}
      </div>
    </BottomSheet>
  );
}

export default StatExplainerSheet;
